import { render, staticRenderFns } from "./BasischeErnaehrung.vue?vue&type=template&id=0b77c4b3&"
import script from "./BasischeErnaehrung.vue?vue&type=script&lang=js&"
export * from "./BasischeErnaehrung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports